import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { get, map, set } from 'lodash';
import shortid from 'shortid';

/*************************************************************/

/**
 * @type {class}
 * @desc MemberDetailsArEntityWidget defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberDetailsArEntityWidgetService } from 'services/memberDetailsAREntityWidget';
 *
 * // create service instance and send/cancel request
 * const memberDetailsArEntityWidgetService = new MemberDetailsArEntityWidgetService();
 * const result = await memberDetailsArEntityWidgetService.fetchData( '<user-id>' ); // fetch data
 * memberDetailsArEntityWidgetService.cancel(); // cancel an active request
 */
export class MemberDetailsArEntityWidgetService extends HttpService {

    // make request and fetch data
    async fetchData(  { url = {}, data = {} } = {}  ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            const component = get( response, 'body.component', {} );
            const items = get( component, 'data.state.items' );

            const _items = map( items, item => {
                item.values.orderId = item.id;
                item.id = shortid.generate();
                return item;
            } );

            set( component, 'data.state.items', _items );
            
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
                data: component,
            };
            
        } catch( errResponse ) {
            return this._errorFormatter( errResponse );
        }
    }
}
